/* eslint-disable react-hooks/exhaustive-deps */
import {
    CSSProperties,
    useEffect,
    useState,
} from "react"
import { Tab, Tabs } from "@material-ui/core"
import {
    StyledNavBar,
} from "./Organization_styles"
import { TabPanel } from "react-headless-tabs"
import { useHistory } from "react-router-dom";
import startCase from "lodash/startCase"
import lowerCase from "lodash/lowerCase"
import Colors from "modules/Colors"
import { OrganizationTab } from "./Organization_constants"
import { useLocation } from "react-router-dom"
import OrganizationTabBrands from "./tabViews/OrganizationTabBrands"
import OrganizationTabBilling from "./tabViews/OrganizationTabBilling/OrganizationTabBilling"
import OrganizationTabTeam from "./tabViews/OrganizationTabTeam"
import OrganizationTabCampaigns from "./tabViews/OrganizationTabCampaigns"
import OrganizationSubscriptionStatusBanner from "components/shareable/OrganizationSubscriptionStatusBanner"
import useOrganization from 'Hooks/useOrganization'
import QuickActionPanel, { POPULAR_PLAYBOOKS, QuickActionItem } from "components/shareable/QuickActions"
import OrganizationTabWebsites from "./tabViews/OrganizationTabWebsites"
import { Body2 } from "components/shareable/Typography"
import Intercom from "helpers/Intercom"
import ButtonSymphony from "elements/ButtonSymphony"
import useBrand, { BrandExistsState } from 'Hooks/useBrand';
import { PlanType, PlaybookTypeInfo } from "modules/Const"
import { StyledLabelP } from "modules/Sty";
import OrganizationTabFans from "./tabViews/OrganizationTabFans"

const tabs = [
    OrganizationTab.BRANDS,
    OrganizationTab.TEAM,
    OrganizationTab.MARKETING_CAMPAIGNS,
    OrganizationTab.WEBSITES,
    OrganizationTab.FANS,
    OrganizationTab.BILLING,
].map((tab) => ({
    value: tab,
    name: startCase(lowerCase(tab)),
}))

const OrganizationTabs = () => {
    const history = useHistory()
    const location = useLocation()
    const {
        loadedBrands,
        loadedBrandsDict,
    } = useBrand() as BrandExistsState;

    const {
        remainingFreeTrial,
        isOrganizationInactive,
        isPaymentFailed,
        organization,
        organizationBrandIds,
        isLoadingTab,
    } = useOrganization()

    const queryParams = new URLSearchParams(location.search);
    const tabFromQuery = queryParams.get('tab') as OrganizationTab;

    useEffect(() => {
        if (tabFromQuery && Object.values(OrganizationTab).includes(tabFromQuery)) {
            setOrganizationTabs(tabFromQuery);
        }
    }, [tabFromQuery]);

    const [organizationTabs, setOrganizationTabs] = useState<OrganizationTab>(OrganizationTab.BRANDS)

    const proArtists = organizationBrandIds.filter(brandId => loadedBrandsDict[brandId]?.tier === PlanType.PRO);
    let showBanner = isPaymentFailed() || remainingFreeTrial() > 0 || isOrganizationInactive()

    const defaultQuickActionItems: QuickActionItem[] = [
        {
            key: "music",
            title: "Build a Music Site",
            icon: 'musicSite',
            link: undefined,
            isWebsite: true
        },
        ...POPULAR_PLAYBOOKS.map((playbook: PlaybookTypeInfo) => ({
            key: playbook.playbookType,
            title: playbook.title,
            icon: playbook.icon,
            link: `/marketing/new/${playbook.playbookType}`,
            isWebsite: false
        }))
    ];

    const handleQuickActionClick = (itemKey: string) => {
        const item = defaultQuickActionItems.find(i => i.key === itemKey);
        if (item?.isWebsite) {
            // Handle website creation
            return
        } else {
            // Navigate to campaign creation
            history.push(`/marketing/new/${itemKey}`);
        }
    };

    const handleTabChange = (_event: any, newValue: OrganizationTab) => {
        setOrganizationTabs(newValue)
        history.push(`${location.pathname}?tab=${newValue}`)
    }

    const renderOrganizationTabs = () => {
        return (
            <div className="organizationTabsPanelsContainer">
                <TabPanel hidden={organizationTabs !== OrganizationTab.BRANDS}>
                    <OrganizationTabBrands />
                </TabPanel>

                <TabPanel hidden={organizationTabs !== OrganizationTab.TEAM}>
                    <OrganizationTabTeam />
                </TabPanel>

                {organizationTabs == OrganizationTab.MARKETING_CAMPAIGNS && // NOTE: this forces componentDidMount
                    <TabPanel hidden={organizationTabs !== OrganizationTab.MARKETING_CAMPAIGNS}>
                        <OrganizationTabCampaigns organizationBrands={loadedBrands!} />
                    </TabPanel>
                }

                {organizationTabs == OrganizationTab.WEBSITES && // NOTE: this forces componentDidMount
                    <TabPanel hidden={organizationTabs !== OrganizationTab.WEBSITES}>
                        <OrganizationTabWebsites organizationBrands={loadedBrands!} />
                    </TabPanel>
                }

                {organizationTabs == OrganizationTab.FANS && // NOTE: this forces componentDidMount
                    <TabPanel hidden={organizationTabs !== OrganizationTab.FANS}>
                        <OrganizationTabFans />
                    </TabPanel>
                }

                {organizationTabs == OrganizationTab.BILLING && // NOTE: this forces componentDidMount
                    <TabPanel hidden={organizationTabs !== OrganizationTab.BILLING}>
                        <OrganizationTabBilling />
                    </TabPanel>
                }
            </div>
        )
    }

    // NOTE: render()
    return (
        <>
            {showBanner &&
                <OrganizationSubscriptionStatusBanner />
            }
            <QuickActionPanel
                className="organizationQuickActions"
                askMaestroSource="Marketing - Team Plan"
                campaignCreationSource="team-plan-quick-actions"
                campaignItems={defaultQuickActionItems}
                allowBrandSelector
                loadedBrands={loadedBrands}
                handleQuickActionClick={handleQuickActionClick}
            />

            <div
                className="organizationHeaderCardComponent"
                style={sty.organizationHeaderCardComponent}
            >
                <StyledLabelP className="organizationHeaderTitle" fontSize={28}>
                    {organization?.name}
                </StyledLabelP>
                <div className="organizationHeaderStats flex flex-row items-center mt-5">
                    <Body2 className="totalProfilesLabel mr-2">
                        Total Profiles
                    </Body2>
                    <p className="totalArtistsCount mr-1">
                        {organizationBrandIds?.length}
                    </p>
                    <Body2 className="activeProAccounts ml-5 mr-2">
                        Active Pro Accounts
                    </Body2>
                    <p className="proArtistsCount">
                        {proArtists.length}
                    </p>
                    <ButtonSymphony
                        className="buttonContactSupportOrganizationTabs"
                        style={{ marginLeft: 'auto' }}
                        onClick={() => Intercom.showNewMessage()}
                        variant="text"
                        size="small"
                    >
                        Contact Support
                    </ButtonSymphony>
                </div>

                <StyledNavBar className="organizationNavHeaderTabs">
                    <Tabs
                        style={{ flex: '1' }}
                        scrollButtons="auto"
                        variant="scrollable"
                        value={organizationTabs}
                        onChange={handleTabChange}
                        aria-label="Settings Options Selector"
                        TabIndicatorProps={{
                            style: { backgroundColor: Colors.purple },
                        }}
                    >
                        {tabs.map(({ name, value }) => (
                            <Tab
                                key={value}
                                disableRipple
                                value={value}
                                label={
                                    <span className="capitalize font-medium text-base px-4 py-2">
                                        {name}
                                    </span>
                                }
                            />
                        ))}
                    </Tabs>
                </StyledNavBar>
                {renderOrganizationTabs()}
            </div>
        </>
    )
}

const sty: Record<string, CSSProperties> = {
    organizationHeaderCardComponent: {
        width: "100%",
        backgroundColor: "white",
        borderRadius: 8,
        padding: 24
    },
}

export default OrganizationTabs;